/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/work_order_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./work_order_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient =
  function WorkOrderServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient =
  function WorkOrderServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateWorkOrderRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkOrder>}
 */
const methodDescriptor_WorkOrderService_CreateWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrder",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateWorkOrderRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkOrder,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateWorkOrderRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkOrder.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.createWorkOrder =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CreateWorkOrder,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkOrder>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.createWorkOrder =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CreateWorkOrder
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListWorkOrdersRequest,
 *   !proto.stronachgroup.first.racehorse360.ListWorkOrdersResponse>}
 */
const methodDescriptor_WorkOrderService_ListWorkOrders =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrders",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListWorkOrdersRequest,
    stronachgroup_first_racehorse360_messages_pb.ListWorkOrdersResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListWorkOrdersRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListWorkOrdersResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListWorkOrdersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListWorkOrdersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.listWorkOrders =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrders",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_ListWorkOrders,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListWorkOrdersResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.listWorkOrders =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrders",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_ListWorkOrders
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListWorkOrderTypesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListWorkOrderTypesResponse>}
 */
const methodDescriptor_WorkOrderService_ListWorkOrderTypes =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderTypes",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListWorkOrderTypesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListWorkOrderTypesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListWorkOrderTypesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListWorkOrderTypesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkOrderTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListWorkOrderTypesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListWorkOrderTypesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.listWorkOrderTypes =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderTypes",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_ListWorkOrderTypes,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkOrderTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListWorkOrderTypesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.listWorkOrderTypes =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderTypes",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_ListWorkOrderTypes
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CloseWorkOrderRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkOrder>}
 */
const methodDescriptor_WorkOrderService_CloseWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CloseWorkOrder",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CloseWorkOrderRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkOrder,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CloseWorkOrderRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkOrder.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CloseWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.closeWorkOrder =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CloseWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CloseWorkOrder,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CloseWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkOrder>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.closeWorkOrder =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CloseWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CloseWorkOrder
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CompleteWorkOrderRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkOrder>}
 */
const methodDescriptor_WorkOrderService_CompleteWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CompleteWorkOrder",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CompleteWorkOrderRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkOrder,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CompleteWorkOrderRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkOrder.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CompleteWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.completeWorkOrder =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CompleteWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CompleteWorkOrder,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CompleteWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkOrder>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.completeWorkOrder =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CompleteWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CompleteWorkOrder
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ReopenWorkOrderRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkOrder>}
 */
const methodDescriptor_WorkOrderService_ReopenWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/ReopenWorkOrder",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ReopenWorkOrderRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkOrder,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ReopenWorkOrderRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkOrder.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ReopenWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.reopenWorkOrder =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ReopenWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_ReopenWorkOrder,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ReopenWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkOrder>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.reopenWorkOrder =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ReopenWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_ReopenWorkOrder
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteWorkOrderRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_WorkOrderService_DeleteWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrder",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteWorkOrderRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkOrderRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.deleteWorkOrder =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_DeleteWorkOrder,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.deleteWorkOrder =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_DeleteWorkOrder
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkOrderNote>}
 */
const methodDescriptor_WorkOrderService_CreateWorkOrderNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrderNote",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateWorkOrderNoteRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkOrderNote,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkOrderNote.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkOrderNote)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkOrderNote>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.createWorkOrderNote =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrderNote",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CreateWorkOrderNote,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkOrderNote>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.createWorkOrderNote =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrderNote",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CreateWorkOrderNote
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_WorkOrderService_DeleteWorkOrderNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrderNote",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteWorkOrderNoteRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.deleteWorkOrderNote =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrderNote",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_DeleteWorkOrderNote,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.deleteWorkOrderNote =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrderNote",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_DeleteWorkOrderNote
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CancelWorkOrderRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkOrder>}
 */
const methodDescriptor_WorkOrderService_CancelWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CancelWorkOrder",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CancelWorkOrderRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkOrder,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CancelWorkOrderRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkOrder.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CancelWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.cancelWorkOrder =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CancelWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CancelWorkOrder,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CancelWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkOrder>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.cancelWorkOrder =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CancelWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_CancelWorkOrder
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.EditWorkOrderRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkOrder>}
 */
const methodDescriptor_WorkOrderService_EditWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/EditWorkOrder",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.EditWorkOrderRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkOrder,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.EditWorkOrderRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkOrder.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.editWorkOrder =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/EditWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_EditWorkOrder,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkOrder>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.editWorkOrder =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/EditWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_EditWorkOrder
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SendBackWorkOrderRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkOrder>}
 */
const methodDescriptor_WorkOrderService_SendBackWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/SendBackWorkOrder",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SendBackWorkOrderRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkOrder,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SendBackWorkOrderRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkOrder.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SendBackWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.sendBackWorkOrder =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/SendBackWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_SendBackWorkOrder,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SendBackWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkOrder>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.sendBackWorkOrder =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/SendBackWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_SendBackWorkOrder
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest,
 *   !proto.stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse>}
 */
const methodDescriptor_WorkOrderService_PullWorkOrderSummary =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderSummary",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullWorkOrderSummaryRequest,
    stronachgroup_first_racehorse360_messages_pb.PullWorkOrderSummaryResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullWorkOrderSummaryResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.pullWorkOrderSummary =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderSummary",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_PullWorkOrderSummary,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.pullWorkOrderSummary =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderSummary",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_PullWorkOrderSummary
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkOrder>}
 */
const methodDescriptor_WorkOrderService_AssignMaintenanceUserToWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/AssignMaintenanceUserToWorkOrder",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.AssignMaintenanceUserToWorkOrderRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkOrder,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkOrder.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.assignMaintenanceUserToWorkOrder =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/AssignMaintenanceUserToWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_AssignMaintenanceUserToWorkOrder,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkOrder>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.assignMaintenanceUserToWorkOrder =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/AssignMaintenanceUserToWorkOrder",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_AssignMaintenanceUserToWorkOrder
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullMaintenanceUsersRequest,
 *   !proto.stronachgroup.first.racehorse360.PullMaintenanceUsersResponse>}
 */
const methodDescriptor_WorkOrderService_PullMaintenanceUsers =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/PullMaintenanceUsers",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullMaintenanceUsersRequest,
    stronachgroup_first_racehorse360_messages_pb.PullMaintenanceUsersResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullMaintenanceUsersRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullMaintenanceUsersResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullMaintenanceUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullMaintenanceUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullMaintenanceUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.pullMaintenanceUsers =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullMaintenanceUsers",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_PullMaintenanceUsers,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullMaintenanceUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullMaintenanceUsersResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.pullMaintenanceUsers =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullMaintenanceUsers",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_PullMaintenanceUsers
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListWorkOrderNotesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListWorkOrderNotesResponse>}
 */
const methodDescriptor_WorkOrderService_ListWorkOrderNotes =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderNotes",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListWorkOrderNotesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListWorkOrderNotesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListWorkOrderNotesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListWorkOrderNotesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkOrderNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListWorkOrderNotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListWorkOrderNotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.listWorkOrderNotes =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderNotes",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_ListWorkOrderNotes,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkOrderNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListWorkOrderNotesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.listWorkOrderNotes =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderNotes",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_ListWorkOrderNotes
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullWorkOrderReportersRequest,
 *   !proto.stronachgroup.first.racehorse360.PullWorkOrderReportersResponse>}
 */
const methodDescriptor_WorkOrderService_PullWorkOrderReporters =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderReporters",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullWorkOrderReportersRequest,
    stronachgroup_first_racehorse360_messages_pb.PullWorkOrderReportersResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullWorkOrderReportersRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullWorkOrderReportersResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWorkOrderReportersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullWorkOrderReportersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullWorkOrderReportersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.pullWorkOrderReporters =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderReporters",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_PullWorkOrderReporters,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWorkOrderReportersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullWorkOrderReportersResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.pullWorkOrderReporters =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderReporters",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_PullWorkOrderReporters
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest,
 *   !proto.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse>}
 */
const methodDescriptor_WorkOrderService_PullWorkOrderAssignedUsers =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderAssignedUsers",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullWorkOrderAssignedUsersRequest,
    stronachgroup_first_racehorse360_messages_pb.PullWorkOrderAssignedUsersResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullWorkOrderAssignedUsersResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkOrderServiceClient.prototype.pullWorkOrderAssignedUsers =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderAssignedUsers",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_PullWorkOrderAssignedUsers,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkOrderServicePromiseClient.prototype.pullWorkOrderAssignedUsers =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderAssignedUsers",
      request,
      metadata || {},
      methodDescriptor_WorkOrderService_PullWorkOrderAssignedUsers
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
